/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestDisplay } from './QuestDisplay';
import {
    QuestDisplayFromJSON,
    QuestDisplayFromJSONTyped,
    QuestDisplayToJSON,
    QuestDisplayToJSONTyped,
} from './QuestDisplay';
import type { JourneySegment } from './JourneySegment';
import {
    JourneySegmentFromJSON,
    JourneySegmentFromJSONTyped,
    JourneySegmentToJSON,
    JourneySegmentToJSONTyped,
} from './JourneySegment';

/**
 * 
 * @export
 * @interface Journey
 */
export interface Journey {
    /**
     * 
     * @type {string}
     * @memberof Journey
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Journey
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof Journey
     */
    updatedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof Journey
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Journey
     */
    description?: string;
    /**
     * Adaptive track this journey represents (e.g. Play, Drop-In, Social, Collect). The router assigns a user to a track; the admin authors each track's tree.
     * @type {string}
     * @memberof Journey
     */
    track?: string;
    /**
     * 
     * @type {Array<QuestDisplay>}
     * @memberof Journey
     */
    displayedOn: Array<QuestDisplay>;
    /**
     * 
     * @type {Array<JourneySegment>}
     * @memberof Journey
     */
    segments?: Array<JourneySegment>;
    /**
     * 
     * @type {boolean}
     * @memberof Journey
     */
    isActive?: boolean;
    /**
     * Epoch ms this journey goes live. Unset = live as soon as it is active.
     * @type {number}
     * @memberof Journey
     */
    startAt?: number;
    /**
     * Epoch ms this journey stops being live. Unset = never expires.
     * @type {number}
     * @memberof Journey
     */
    endAt?: number;
    /**
     * Tiebreak when several journeys are live at once on the same surface and track — higher wins. Defaults to 0.
     * @type {number}
     * @memberof Journey
     */
    priority?: number;
}

/**
 * Check if a given object implements the Journey interface.
 */
export function instanceOfJourney(value: object): value is Journey {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayedOn' in value) || value['displayedOn'] === undefined) return false;
    return true;
}

export function JourneyFromJSON(json: any): Journey {
    return JourneyFromJSONTyped(json, false);
}

export function JourneyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Journey {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'track': json['track'] == null ? undefined : json['track'],
        'displayedOn': ((json['displayedOn'] as Array<any>).map(QuestDisplayFromJSON)),
        'segments': json['segments'] == null ? undefined : ((json['segments'] as Array<any>).map(JourneySegmentFromJSON)),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'priority': json['priority'] == null ? undefined : json['priority'],
    };
}

export function JourneyToJSON(json: any): Journey {
    return JourneyToJSONTyped(json, false);
}

export function JourneyToJSONTyped(value?: Journey | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'name': value['name'],
        'description': value['description'],
        'track': value['track'],
        'displayedOn': ((value['displayedOn'] as Array<any>).map(QuestDisplayToJSON)),
        'segments': value['segments'] == null ? undefined : ((value['segments'] as Array<any>).map(JourneySegmentToJSON)),
        'isActive': value['isActive'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'priority': value['priority'],
    };
}

